import { render, staticRenderFns } from "./FancafeItem.vue?vue&type=template&id=61a8cd98&"
import script from "./FancafeItem.vue?vue&type=script&lang=js&"
export * from "./FancafeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61a8cd98', component.options)
    } else {
      api.reload('61a8cd98', component.options)
    }
    module.hot.accept("./FancafeItem.vue?vue&type=template&id=61a8cd98&", function () {
      api.rerender('61a8cd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/FancafeItem.vue"
export default component.exports